{
  "id": "campaign-088",
  "name": "Mossy Walk",
  "seed": "campaign:88",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "X...L__L...X",
    "..X..__.....",
    ".,.,.__.....",
    ".i,i.__.i.i.",
    "....X__X....",
    "..X..__..X..",
    ".T...__X..T.",
    "____________",
    "X.X,.__X.~~~",
    "..,i,__.i...",
    ".L...__...L.",
    "..X..__X....",
    "...,x__.%..X",
    ".X...__.%%..",
    "..X,.x..%...",
    "S..........."
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 3,
      "y": 10
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 13
    },
    {
      "kind": "rabbit",
      "x": 3,
      "y": 5
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 2
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 2
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 13
    },
    {
      "kind": "rare",
      "x": 5,
      "y": 12
    },
    {
      "kind": "repair",
      "x": 0,
      "y": 2
    }
  ],
  "falls": [
    {
      "x": 1,
      "y": 13,
      "dir": "E",
      "at": 29,
      "length": 3
    }
  ],
  "generatorVersion": 3,
  "level": 88,
  "biome": "cemetery",
  "par": {
    "reel": 6383,
    "push": 4710,
    "selfPropelled": 4860,
    "tractor": 4130,
    "zeroTurn": 3084,
    "fairway": 2368
  },
  "routeTries": {
    "par": {
      "reel": 13,
      "push": 2,
      "selfPropelled": 12,
      "tractor": 0,
      "zeroTurn": 19,
      "fairway": 1
    }
  }
}
